import dayjs from 'dayjs';
import 'dayjs/locale/it';

// Le istanze di Intl.NumberFormat si creano una volta sola: costruirne una per cella
// è la voce di costo tipica delle tabelle lunghe.
const INTEGER = new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0 });
const DECIMAL_1 = new Intl.NumberFormat('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

/**
 * null, undefined e stringa vuota NON sono zero: `Number(null)` vale 0, e formattarlo come tale
 * mostrerebbe uno zero inventato su una pagina il cui unico contenuto è un numero da verificare.
 */
const isNumero = (value) =>
  value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value));

/** 12480 → "12.480" */
export const formatInt = (value) => (isNumero(value) ? INTEGER.format(Number(value)) : '—');

/** 4.23 → "4,2" */
export const formatDecimal1 = (value) => (isNumero(value) ? DECIMAL_1.format(Number(value)) : '—');

/** 4.23 → "4,2%" */
export const formatPercent1 = (value) =>
  isNumero(value) ? `${DECIMAL_1.format(Number(value))}%` : '—';

/**
 * Variazione rispetto al periodo precedente: "+12,4%" / "−8,1%" / "n.d.".
 * Il meno è il segno tipografico (U+2212), non il trattino: allineato ai numeri.
 */
export const formatDelta = (value) => {
  if (!isNumero(value)) {
    return 'n.d.';
  }
  const n = Number(value);
  const sign = n > 0 ? '+' : n < 0 ? '−' : '';
  return `${sign}${DECIMAL_1.format(Math.abs(n))}%`;
};

/** "18 set 2026" */
export const formatDay = (date) => dayjs(date).locale('it').format('D MMM YYYY');

/** "18 set" — per le etichette degli assi, dove l'anno è ridondante */
export const formatDayShort = (date) => dayjs(date).locale('it').format('D MMM');

/**
 * "20" — solo il numero del giorno, per l'asse giornaliero: trenta etichette "20 ago" non ci
 * stanno, e Recharts ne scartava una su due. Il mese lo stampa chi costruisce l'asse, dove cambia.
 */
export const formatDayNumber = (date) => dayjs(date).locale('it').format('D');

/** "settembre 2026" */
export const formatMonth = (date) => dayjs(date).locale('it').format('MMMM YYYY');

/**
 * "set" — per le etichette degli assi, come formatDayShort: l'anno è ridondante (il periodo lo
 * dichiara il selettore) e "settembre 2026" è largo abbastanza da far scartare a Recharts i mesi
 * vicini, che sparivano dall'asse senza che mancasse il dato.
 */
export const formatMonthShort = (date) => dayjs(date).locale('it').format('MMM');

/** "18 ago – 16 set 2026": l'anno si ripete solo se i due estremi non lo condividono */
export const formatRange = (from, to) => {
  const start = dayjs(from).locale('it');
  const end = dayjs(to).locale('it');
  if (!start.isValid() || !end.isValid()) {
    return '—';
  }
  return start.year() === end.year()
    ? `${start.format('D MMM')} – ${end.format('D MMM YYYY')}`
    : `${start.format('D MMM YYYY')} – ${end.format('D MMM YYYY')}`;
};
